import { render, staticRenderFns } from "./yq-tabbar.vue?vue&type=template&id=e43bc6d4&scoped=true"
import script from "./yq-tabbar.vue?vue&type=script&lang=js"
export * from "./yq-tabbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43bc6d4",
  null
  
)

export default component.exports